// import React from 'react';
// import { alpha, useTheme } from '@mui/material/styles';
// import { SimTypography } from 'components/SimTypography';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';

// const SimSummary = props => {
// 	const theme = useTheme();

// 	return (
// 		<Box>
// 			<Box
// 				sx={{
// 					backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
// 						theme.palette.background.default,
// 						0
// 					)} 100%)`
// 				}}>
// 				<Box
// 					display='flex'
// 					justifyContent='center'
// 					alignItems={'center'}
// 					alignContent='center'
// 					height={1}
// 					width={1}>
// 					<Box
// 						paddingX={2}
// 						width={1}
// 						sx={{
// 							bgcolor: 'rgba(0, 0, 0, 0)'
// 						}}
// 						display='flex'
// 						justifyContent='center'
// 						alignContent={'center'}
// 						alignItems={'center'}>
// 						<Container>
// 							<Box>
// 								<SimTypography
// 									color={theme.palette.secondary.main}
// 									sx={{
// 										textTransform: 'uppercase',
// 										fontWeight: 'medium'
// 									}}
// 									gutterBottom
// 									align={'left'}>
// 									{props.text}
// 								</SimTypography>

// 								<SimTypography
// 									color={theme.palette.primary.main}
// 									variant='h4'
// 									align={'left'}
// 									paddingcenter='2vw'
// 									data-aos={'fade-up'}
// 									gutterBottom
// 									sx={{
// 										fontWeight: 700,
// 										marginTop: theme.spacing(1)
// 									}}>
// 									{props.topTitle}
// 									<br />
// 									{props.bottomTitle}
// 								</SimTypography>

// 								<SimTypography
// 									color={theme.palette.text.primary}
// 									variant='h6'
// 									align={'left'}
// 									data-aos={'fade-up'}>
// 									{props.topContent}
// 									<br />
// 									{props.bottomContent}
// 								</SimTypography>
// 							</Box>
// 						</Container>
// 					</Box>
// 				</Box>
// 			</Box>
// 		</Box>
// 	);
// };

// export default SimSummary;


import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { SimTypography } from 'components/SimTypography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const SimSummary = props => {
    const theme = useTheme();

    return (
        <Box>
            <Box
                // sx={{
                //     // --- THIS IS THE FIX ---
                //     // Changed 'theme.palette.divider.dark' to 'theme.palette.divider'
                //     // backgroundImage: `linear-gradient(${alpha(theme.palette.divider, 1)} 0%, ${alpha(
                //     //     theme.palette.background.default,
                //     //     0
                //     // )} 100%)`
                // }}>
                sx={{
					backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
						theme.palette.background.default,
						0
					)} 100%)`
				}}>
                <Box
                    display='flex'
                    justifyContent='center'
                    alignItems={'center'}
                    alignContent='center'
                    height={1}
                    width={1}>
                    <Box
                        paddingX={2}
                        width={1}
                        sx={{
                            bgcolor: 'rgba(0, 0, 0, 0)'
                        }}
                        display='flex'
                        justifyContent='center'
                        alignContent={'center'}
                        alignItems={'center'}>
                        <Container>
                            <Box>
                                <SimTypography
                                    color={theme.palette.secondary.main}
                                    sx={{
                                        textTransform: 'uppercase',
                                        fontWeight: 'medium'
                                    }}
                                    gutterBottom
                                    align={'left'}>
                                    {props.text}
                                </SimTypography>

                                <SimTypography
                                    color={theme.palette.primary.main}
                                    variant='h4'
                                    align={'left'}
                                    paddingcenter='2vw'
                                    data-aos={'fade-up'}
                                    gutterBottom
                                    sx={{
                                        fontWeight: 700,
                                        marginTop: theme.spacing(1)
                                    }}>
                                    {props.topTitle}
                                    <br />
                                    {props.bottomTitle}
                                </SimTypography>

                                <SimTypography
                                    color={theme.palette.text.primary}
                                    variant='h6'
                                    align={'left'}
                                    data-aos={'fade-up'}>
                                    {props.topContent}
                                    <br />
                                    {props.bottomContent}
                                </SimTypography>
                            </Box>
                        </Container>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default SimSummary;